import apiClient from "./config";


export const getPdfByDealId = async (dealId) => {
  try {
    const params = { deal_id: dealId };
    const response = await apiClient.get("api/engagement/deal-pdf/", { params });
    console.log("Clients API Response:", response.data);
    const data = response.data;

    if (data && data.deal_pdf_path) {
      return data.deal_pdf_path;
    }

    console.warn("Unexpected clients response format:", data);
    return '';
  } catch (error) {
    console.error("Error fetching clients");
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    }
    return '';
  }
};

export const getDealPmStatus = async (dealId) => {
  const response = await apiClient.get(`api/engagement/deal-pm-status/`, { params: { deal_id: dealId } });
  return response.data;
};

export const getDealPmHistory = async (dealId) => {
  const response = await apiClient.get(`api/engagement/deal-pm-history/`, { params: { deal_id: dealId } });
  return response.data;
};
